export default "__VITE_ASSET__BiTiOTh2__";